/**
 * Proxy Inspector Page
 *
 * Page wrapper for the Proxy Inspector component that provides
 * browser proxy mode inspection and replacement rule management.
 */

import { ProxyInspector } from '../components/proxy/ProxyInspector';

export function ProxyInspectorPage() {
  return (
    <div>
      <ProxyInspector />
    </div>
  );
}
